import { render, staticRenderFns } from "./ProjectStatus.vue?vue&type=template&id=7c136a95&scoped=true&lang=html"
import script from "./ProjectStatus.vue?vue&type=script&lang=js"
export * from "./ProjectStatus.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatus.vue?vue&type=style&index=0&id=7c136a95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c136a95",
  null
  
)

export default component.exports